import { TextInput } from '@pandiafi/design-system'
import { Field, FieldProps } from 'formik'
import { t } from 'i18next'
import React from 'react'

import FormFieldWrapper from 'components/FormField'
import { BeneficiaryType } from 'views/TerminateContract/TerminateForm/initialValues'

interface BeneficiaryBicFieldProps {
  index: number
  required?: boolean
}

export const BeneficiaryBicField: React.FC<BeneficiaryBicFieldProps> = ({
  index,
  required,
}) => {
  return (
    <Field name={`beneficiaries[${index}]bic`}>
      {({ field, meta }: FieldProps<BeneficiaryType['bic']>) => (
        <FormFieldWrapper
          name={field.name}
          required={required}
          label={t('terminateContract:labels.bic')}
          className="min-tablet:flex-1"
          meta={meta}
          labelBold
        >
          <TextInput {...field} />
        </FormFieldWrapper>
      )}
    </Field>
  )
}
